import { useTranslation } from 'react-i18next';
import { Layers, Percent } from 'lucide-react';
import { HomeLayout } from './HomeLayout';

/** A coming-soon exercise in the home frame until the client defines it. */
function SoonScreen({ ns, icon: Icon }: { ns: 'foldEquity' | 'texture'; icon: typeof Percent }) {
  const { t } = useTranslation();
  return (
    <HomeLayout section={t(`${ns}.title`)} backTo="/">
      <div
        className="enter flex flex-col items-center gap-4 rounded-[20px] border-2 border-accent bg-surface px-7 py-12 text-center"
        style={{ boxShadow: 'var(--glow)' }}
      >
        <Icon className="size-12 text-accent" strokeWidth={2} aria-hidden />
        <p className="m-0 max-w-[48ch] text-[15px] leading-[1.7]">{t(`${ns}.soon`)}</p>
      </div>
    </HomeLayout>
  );
}
/** Multi street fold equity */
export const FoldEquityScreen = () => <SoonScreen ns="foldEquity" icon={Percent} />;
/** Board texture development */
export const TextureScreen = () => <SoonScreen ns="texture" icon={Layers} />;
